module.exports = __webpack_public_path__ + "img/39.1.2c8a7dc6.jpg";